export const LearningPlansTabsOptions = [
  { label: 'Overview', value: 0 },
  { label: 'Learning Plan', value: 1 },
];
